(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpn-cta-band"] && !Shopify.designMode) return;
  try {
    
(function() {

  var root    = document.getElementById('lpnCta');
  var bg      = document.getElementById('lpnCtaBg');
  var overlay = document.getElementById('lpnCtaOverlay');
  var content = document.getElementById('lpnCtaContent');
  var form    = document.getElementById('lpnCtaForm');
  var success = document.getElementById('lpnCtaSuccess');
  var btn     = document.getElementById('lpnCtaBtn');
  var errEl   = document.getElementById('lpnCtaError');

  if (!root || !bg) return;

  var KV_KEY  = (root.dataset.klaviyoKey  || '').trim();
  var KV_LIST = (root.dataset.klaviyoList || '').trim();
  var triggered = false;

  /* ── Viewport-entry portal reveal ─────────────────────────── */
  var io = new IntersectionObserver(function(entries) {
    if (triggered || !entries[0].isIntersecting) return;
    triggered = true;
    io.disconnect();

    bg.classList.add('is-open');
    if (overlay) overlay.classList.add('is-dark');

    setTimeout(function() {
      if (content) content.classList.add('is-visible');
    }, 950);
  }, { threshold: 0.25 });

  io.observe(root);

  /* ── Form handling ─────────────────────────────────────────── */
  if (!form || !btn) return;

  function setError(msg) { if (errEl) errEl.textContent = msg; }

  function setLoading(on) {
    btn.disabled = on;
    btn.classList.toggle('lpn-cta__btn--loading', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function showSuccess() {
    if (content) {
      content.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      content.style.opacity    = '0';
      content.style.transform  = 'translateY(-12px)';
    }
    setTimeout(function() {
      if (content) { content.style.display = 'none'; }
      success.style.display = 'flex';
      success.removeAttribute('aria-hidden');
      requestAnimationFrame(function() {
        success.classList.add('is-visible');
        setTimeout(function() { success.style.willChange = ''; }, 650);
      });
    }, 300);
  }

  function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    setError('');

    var email = (form.querySelector('[name="email"]').value || '').trim();

    if (!email || !isValidEmail(email)) {
      setError('Please enter a valid email address.');
      form.querySelector('[name="email"]').focus();
      return;
    }

    if (!KV_KEY || !KV_LIST) {
      console.warn('[LPN] Klaviyo keys not configured — add them in Theme Customizer > Email Capture.');
      showSuccess();
      return;
    }

    setLoading(true);

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Homepage Email Banner',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { signup_source: 'Homepage Email Banner' }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: KV_LIST } } }
      }
    };

    fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KV_KEY),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-02-15' },
        body: JSON.stringify(payload)
      }
    )
    .then(function(res) {
      if (res.status === 202 || res.ok) {
        showSuccess();
      } else {
        return res.text().then(function(body) {
          console.error('[LPN] Klaviyo error', res.status, body);
          setError('Something went wrong. Please try again.');
          setLoading(false);
        });
      }
    })
    .catch(function(err) {
      console.error('[LPN] Network error', err);
      setError('Connection error. Please try again.');
      setLoading(false);
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpn-feature-scroll"] && !Shopify.designMode) return;
  try {
    
(function() {

  var section  = document.getElementById('lpn-fscroll');
  var jar      = document.getElementById('lpnFScrollJar');
  var features = section ? section.querySelectorAll('.lpn-fscroll__feature') : [];
  var dots     = section ? section.querySelectorAll('.lpn-fscroll__dot') : [];
  if (!section || !jar || !features.length) return;

  var currentFeature = 0;
  var rafId          = null;
  var sectionInView  = false;

  /* ── Activate a feature by 1-based index (0 = none) ──────── */
  function activateFeature(index) {
    if (index === currentFeature) return;
    currentFeature = index;

    features.forEach(function(f, i) {
      var active = (i + 1) === index;
      f.classList.toggle('is-active', active);
      f.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    dots.forEach(function(d, i) {
      d.classList.toggle('is-active', (i + 1) === index);
    });
  }

  /* ── Main update — runs on rAF while section is in view ───── */
  function update() {
    var rect       = section.getBoundingClientRect();
    var scrollable = section.offsetHeight - window.innerHeight;
    if (scrollable <= 0) return;

    var progress = Math.max(0, Math.min(1, -rect.top / scrollable));

    /* Feature index: divide 0→1 into 5 equal bands */
    var idx = Math.min(Math.floor(progress * 5) + 1, 5);
    activateFeature(idx);

    /* Jar exit: fades + scales in the final 15% of scroll */
    var exitT = Math.max(0, (progress - 0.85) / 0.15);
    jar.style.opacity  = String(1 - exitT * 0.72);
    jar.style.transform = 'scale(' + (1 - exitT * 0.16) + ')';
  }

  /* ── rAF-throttled scroll handler ─────────────────────────── */
  function onScroll() {
    if (rafId) return;
    rafId = requestAnimationFrame(function() {
      update();
      rafId = null;
    });
  }

  /* ── IO gates the scroll listener ─────────────────────────── */
  var sectionIo = new IntersectionObserver(function(entries) {
    sectionInView = entries[0].isIntersecting;
    if (sectionInView) {
      window.addEventListener('scroll', onScroll, { passive: true });
      update(); /* run immediately on entry */
    } else {
      window.removeEventListener('scroll', onScroll);
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      /* Reset jar when section leaves view */
      jar.style.opacity  = '1';
      jar.style.transform = 'scale(1)';
    }
  }, { threshold: 0 });

  sectionIo.observe(section);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpn-formula"] && !Shopify.designMode) return;
  try {
    
(function() {
  var table = document.getElementById('lpnFormulaTable');
  if (!table) return;

  var rows = table.querySelectorAll('.lpn-formula__row');
  if (!rows.length) return;

  var io = new IntersectionObserver(function(entries) {
    if (!entries[0].isIntersecting) return;

    rows.forEach(function(row, i) {
      row.style.transitionDelay = (i * 0.05) + 's';
      row.classList.add('is-visible');
    });

    /* Clear delays after all rows have animated in so hover stays instant */
    var clearAfter = ((rows.length - 1) * 0.05 + 0.6) * 1000;
    setTimeout(function() {
      rows.forEach(function(row) { row.style.transitionDelay = ''; });
    }, clearAfter);

    io.disconnect();
  }, { threshold: 0.05 });

  io.observe(table);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpn-founding-member"] && !Shopify.designMode) return;
  try {
    
(function() {

  var root    = document.getElementById('lpnFm');
  var wrap    = document.getElementById('lpnFmWrap');
  var bg      = document.getElementById('lpnFmBg');
  var bgImg   = bg ? bg.querySelector('img') : null;
  var overlay = document.getElementById('lpnFmOverlay');
  var brand   = document.getElementById('lpnFmBrand');
  var cue     = document.getElementById('lpnFmCue');
  var cap     = document.getElementById('lpnFmCap');
  var panel   = document.getElementById('lpnFmPanel');
  var form    = document.getElementById('lpnFmForm');
  var success = document.getElementById('lpnFmSuccess');
  var btn     = document.getElementById('lpnFmBtn');
  var errEl   = document.getElementById('lpnFmError');

  if (!root || !wrap || !bg) return;

  var KV_KEY  = (root.dataset.klaviyoKey  || '').trim();
  var KV_LIST = (root.dataset.klaviyoList || '').trim();
  var rafId   = null;

  /* ── Easing + math helpers ─────────────────────────────── */
  function easeOut3(t) { return 1 - Math.pow(1 - t, 3); }
  function easeOut5(t) { return 1 - Math.pow(1 - t, 5); }
  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function phase(t, start, end) { return clamp((t - start) / (end - start), 0, 1); }

  /* ── Scroll reveal ─────────────────────────────────────── */
  function update() {
    rafId = null;
    var rect     = wrap.getBoundingClientRect();
    var maxScroll = wrap.offsetHeight - window.innerHeight;
    if (maxScroll <= 0) return;

    var scrolled = clamp(-rect.top, 0, maxScroll);
    var t = scrolled / maxScroll;

    /* Phase 1 (t 0→0.65): clip-path portal opens + image zooms to natural */
    var t1 = easeOut5(phase(t, 0, 0.65));
    var radius = lerp(9, 160, t1);
    bg.style.clipPath = 'circle(' + radius.toFixed(2) + '% at 50% 44%)';
    if (bgImg) bgImg.style.transform = 'scale(' + lerp(1.8, 1.0, t1).toFixed(4) + ')';
    overlay.style.background = 'rgba(16,24,32,' + lerp(0, 0.58, t1).toFixed(3) + ')';

    /* Phase 2 (t 0.65→1.0): brand headline fades in, cue fades out */
    var t2 = easeOut3(phase(t, 0.65, 1.0));
    if (brand) {
      brand.style.opacity   = t2.toFixed(3);
      brand.style.transform = 'translateY(' + lerp(20, 0, t2).toFixed(2) + 'px)';
    }
    cue.style.opacity = (Math.max(0, 1 - t * 10)).toFixed(3);
  }

  function onScroll() {
    if (!rafId) rafId = requestAnimationFrame(update);
  }

  var revealIO = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting) {
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    } else {
      window.removeEventListener('scroll', onScroll);
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    }
  }, { threshold: 0 });

  revealIO.observe(wrap);
  update();

  /* ── Cap section reveals ───────────────────────────────── */
  if (cap) {
    var revealEls = cap.querySelectorAll('.lpn-fm-reveal');
    if (revealEls.length) {
      var capIO = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          capIO.unobserve(entry.target);
          requestAnimationFrame(function() {
            entry.target.classList.add('is-visible');
          });
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function(el) { capIO.observe(el); });
    }
  }

  /* ── Form ──────────────────────────────────────────────── */
  if (!form || !btn) return;

  function setError(msg) { if (errEl) errEl.textContent = msg; }

  function setLoading(on) {
    btn.disabled = on;
    btn.classList.toggle('lpn-fm__btn--loading', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function showSuccess() {
    panel.style.opacity   = '0';
    panel.style.transform = 'translateY(-14px)';
    panel.style.transition = 'opacity 0.3s ease, transform 0.3s ease';

    setTimeout(function() {
      panel.style.display = 'none';
      panel.setAttribute('aria-hidden', 'true');
      success.style.display = 'flex';
      success.removeAttribute('aria-hidden');
      requestAnimationFrame(function() {
        success.classList.add('is-visible');
        setTimeout(function() { success.style.willChange = ''; }, 700);
      });
    }, 320);
  }

  function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    setError('');

    var email     = (form.querySelector('[name="email"]').value     || '').trim();
    var firstName = (form.querySelector('[name="first_name"]').value || '').trim();

    if (!email || !isValidEmail(email)) {
      setError('Please enter a valid email address.');
      form.querySelector('[name="email"]').focus();
      return;
    }

    if (!KV_KEY || !KV_LIST) {
      console.warn('[LPN] Klaviyo keys not configured — add them in Theme Customizer > Founding Member.');
      showSuccess();
      return;
    }

    setLoading(true);

    var profileAttrs = {
      email: email,
      properties: { founding_member: true, signup_source: 'Founding Member Page' }
    };
    if (firstName) profileAttrs.first_name = firstName;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Founding Member Page',
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: { list: { data: { type: 'list', id: KV_LIST } } }
      }
    };

    fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KV_KEY),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-02-15' },
        body: JSON.stringify(payload)
      }
    )
    .then(function(res) {
      if (res.status === 202 || res.ok) {
        showSuccess();
      } else {
        return res.text().then(function(body) {
          console.error('[LPN] Klaviyo error', res.status, body);
          setError('Something went wrong. Please try again.');
          setLoading(false);
        });
      }
    })
    .catch(function(err) {
      console.error('[LPN] Network error', err);
      setError('Connection error. Please check your internet and try again.');
      setLoading(false);
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpn-hero"] && !Shopify.designMode) return;
  try {
    
(function() {

  /* ─── NAV BEHAVIOUR ──────────────────────────────────── */
  var nav       = document.getElementById('lpnNav');
  var hamburger = document.getElementById('lpnHamburger');
  var mobileMenu = document.getElementById('lpnMobileMenu');
  if (!nav) return;

  var lastY    = 0;
  var ticking  = false;
  var NAV_SHOW_THRESHOLD = 80;

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(function() {
        var y = window.scrollY;

        /* Frosted glass */
        if (y > 40) {
          nav.classList.add('is-scrolled');
        } else {
          nav.classList.remove('is-scrolled');
        }

        /* Hide on scroll down, reveal on scroll up */
        if (y > lastY && y > NAV_SHOW_THRESHOLD) {
          nav.classList.add('is-hidden');
        } else if (y < lastY) {
          nav.classList.remove('is-hidden');
        }

        lastY   = y;
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  /* ─── HAMBURGER ──────────────────────────────────────── */
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      var isOpen = nav.classList.toggle('lpn-nav--open');
      hamburger.setAttribute('aria-expanded', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
    });

    /* Close on outside click */
    document.addEventListener('click', function(e) {
      if (!nav.contains(e.target)) {
        nav.classList.remove('lpn-nav--open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /* ─── SCROLL INDICATOR ───────────────────────────────── */
  var scrollIndicator = document.getElementById('lpnScrollIndicator');
  if (scrollIndicator) {
    var dismissed = false;
    window.addEventListener('scroll', function() {
      if (!dismissed && window.scrollY > 30) {
        dismissed = true;
        scrollIndicator.classList.add('is-gone');
      }
    }, { passive: true, once: false });
  }

  /* ─── HERO CONTENT PARALLAX ─────────────────────────── */
  var heroSection = document.getElementById('lpn-hero');
  var heroContent = heroSection ? heroSection.querySelector('.lpn-hero__content') : null;

  if (heroSection && heroContent) {
    var hRaf = null;

    function runParallax() {
      var scrollY = window.scrollY;
      hRaf = null;
      if (scrollY <= 0) {
        heroContent.style.transform = '';
        heroContent.style.opacity   = '';
        return;
      }
      var t = Math.min(scrollY / heroSection.offsetHeight, 1);
      /* Content drifts upward at 45% of scroll speed */
      heroContent.style.transform = 'translateY(' + -(scrollY * 0.45) + 'px)';
      /* Fades to zero by the time 50% of the hero has scrolled past */
      heroContent.style.opacity = String(Math.max(0, 1 - t * 2.0));
    }

    function onParallaxScroll() {
      if (!hRaf) hRaf = requestAnimationFrame(runParallax);
    }

    var heroIO = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        heroContent.style.willChange = 'transform, opacity';
        window.addEventListener('scroll', onParallaxScroll, { passive: true });
        runParallax();
      } else {
        window.removeEventListener('scroll', onParallaxScroll);
        if (hRaf) { cancelAnimationFrame(hRaf); hRaf = null; }
        heroContent.style.transform  = '';
        heroContent.style.opacity    = '';
        heroContent.style.willChange = '';
      }
    }, { threshold: 0 });

    heroIO.observe(heroSection);
  }

  /* ─── SHARED REVEAL OBSERVER ─────────────────────────── */
  document.addEventListener('DOMContentLoaded', function() {
    var els = document.querySelectorAll('.lpn-reveal');
    if (!els.length) return;
    /* Hint GPU before elements animate */
    els.forEach(function(el) { el.style.willChange = 'transform, opacity'; });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          io.unobserve(e.target);
          requestAnimationFrame(function() {
            e.target.classList.add('is-visible');
            /* Free GPU memory once transition is done */
            setTimeout(function() { e.target.style.willChange = ''; }, 700);
          });
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { io.observe(el); });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpn-product-moment"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Emerge observer — separate threshold from standard reveal */
  var jar = document.getElementById('lpnMomentJar');
  var statement = document.getElementById('lpnMomentStatement');
  if (!jar) return;

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.18 });

  io.observe(jar);
  if (statement) io.observe(statement);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpn-social"] && !Shopify.designMode) return;
  try {
    
(function() {
  var track = document.getElementById('lpnSocialTrack');
  if (!track) return;

  var cards = Array.from(track.children);
  cards.forEach(function(card) {
    track.appendChild(card.cloneNode(true));
  });

  var reel = document.getElementById('lpnSocialReel');
  if (!reel) return;

  var isDown = false;
  var startX = 0;
  var scrollLeft = 0;

  reel.addEventListener('mousedown', function(e) {
    isDown = true;
    startX = e.pageX - reel.offsetLeft;
    scrollLeft = reel.scrollLeft;
    track.style.animationPlayState = 'paused';
  });
  reel.addEventListener('mouseleave', function() {
    isDown = false;
    track.style.animationPlayState = '';
  });
  reel.addEventListener('mouseup', function() {
    isDown = false;
    track.style.animationPlayState = '';
  });
  reel.addEventListener('mousemove', function(e) {
    if (!isDown) return;
    e.preventDefault();
    var x = e.pageX - reel.offsetLeft;
    reel.scrollLeft = scrollLeft - (x - startX);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpn-stat-row"] && !Shopify.designMode) return;
  try {
    
(function() {
  function countUp(el, target, duration) {
    var start = performance.now();
    function step(now) {
      var p = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.floor(eased * target).toLocaleString();
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target.toLocaleString();
    }
    requestAnimationFrame(step);
  }

  var triggered = false;
  var section = document.getElementById('lpn-stats');
  if (!section) return;

  var io = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting && !triggered) {
      triggered = true;
      section.querySelectorAll('.lpn-stat').forEach(function(stat) {
        var target = parseInt(stat.dataset.target, 10);
        var countEl = stat.querySelector('.lpn-stat__count');
        if (countEl) countUp(countEl, target, 1600);
      });
      io.disconnect();
    }
  }, { threshold: 0.3 });

  io.observe(section);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpn-story"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.getElementById('lpn-story');
  if (!section) return;

  var els = section.querySelectorAll('.lpn-story-r');
  if (!els.length) return;

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      requestAnimationFrame(function() {
        entry.target.classList.add('is-visible');
      });
    });
  }, { threshold: 0.12 });

  els.forEach(function(el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
